import { TemplateMeasure, ITemplateMeasureGroup } from "../bundles/entities.bundle";

export class TemplateMeasureDetails {
    constructor() {
        this.templateMeasures = new Array<TemplateMeasure>();
    }

    templateMeasureGroup: ITemplateMeasureGroup;
    templateMeasures: Array<TemplateMeasure>;
    clientId: number;
}